// src/service/Comunicaciones.js
//
// Correos masivos del panel (Comunicaciones) y la baja pública.
// El interceptor de axios ya devuelve el body: `{ success, data, pagination? }`.

import instance from '../apis/app';

const BASE = '/admin/comunicaciones';

const qs = (params = {}) => {
  const limpio = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''));
  const s = new URLSearchParams(limpio).toString();
  return s ? `?${s}` : '';
};

/** Mensaje legible de un error del API (con el detalle de validación si viene). */
export const mensajeError = (e, porDefecto = 'Ocurrió un error') => {
  const body = e?.response?.data;
  if (body?.detalles?.length) return body.detalles.join(' ');
  return body?.message || body?.error || e?.message || porDefecto;
};

const Comunicaciones = {
  listar: (params) => instance.get(`${BASE}${qs(params)}`),
  opciones: async () => (await instance.get(`${BASE}/opciones`))?.data,
  publico: async (segmento, config = {}) => (await instance.post(`${BASE}/publico`, segmento, config))?.data,
  previsualizar: async (payload) => (await instance.post(`${BASE}/previsualizar`, payload))?.data,
  obtener: async (id) => (await instance.get(`${BASE}/${id}`))?.data,
  entregas: (id, params) => instance.get(`${BASE}/${id}/entregas${qs(params)}`),
  crear: async (payload) => (await instance.post(BASE, payload))?.data,
  actualizar: async (id, payload) => (await instance.put(`${BASE}/${id}`, payload))?.data,
  eliminar: (id) => instance.delete(`${BASE}/${id}`),
  prueba: async (id, para) => (await instance.post(`${BASE}/${id}/prueba`, { para }))?.data,
  encolar: async (id, huella) => (await instance.post(`${BASE}/${id}/encolar`, { huella }))?.data,
  cancelar: async (id) => (await instance.post(`${BASE}/${id}/cancelar`))?.data,

  // Públicas (token firmado del enlace)
  estadoBaja: async (t) => (await instance.get(`/comunicaciones/baja${qs({ t })}`, { skipAuth: true }))?.data,
  darDeBaja: async (t) => (await instance.post('/comunicaciones/baja', { token: t }, { skipAuth: true }))?.data,
  deshacerBaja: async (t) => (await instance.post('/comunicaciones/baja/deshacer', { token: t }, { skipAuth: true }))?.data,
};

export default Comunicaciones;
